const initialState = {
  isOpen: false,
  isOpenedWithKeyboard: false,
  items: [],
  highlightedItemId: "",
  hasSearch: false,
  keepHighlight: false
};
function reducer(state, action) {
  var _a, _b;
  if (action.type === "open") {
    return {
      ...state,
      isOpen: true
    };
  }
  if (action.type === "close") {
    return {
      ...initialState
    };
  }
  if (action.type === "toggle") {
    return {
      ...initialState,
      isOpen: !state.isOpen
    };
  }
  if (action.type === "toggle-from-keyboard") {
    return {
      ...initialState,
      isOpen: !state.isOpen,
      isOpenedWithKeyboard: !state.isOpen
      // this is not a typo, it should be synced with isOpen
    };
  }
  if (action.type === "highlight-current-item") {
    const selectedItem = state.items.find((item) => item.isSelected);
    if (state.hasSearch && selectedItem) {
      return {
        ...state,
        highlightedItemId: selectedItem.id
      };
    }
    if (state.isOpenedWithKeyboard && state.items.length) {
      return {
        ...state,
        highlightedItemId: state.items[0].id
      };
    }
    return state;
  }
  if (action.type === "highlight-item") {
    return {
      ...state,
      highlightedItemId: action.payload,
      keepHighlight: true
    };
  }
  if (action.type === "highlight-previous") {
    if (state.items.length === 0) {
      return state;
    }
    const parentId = (_a = state.items.find((item) => item.id === state.highlightedItemId)) == null ? void 0 : _a.parentId;
    const items = state.items.filter((item) => item.parentId === parentId && !item.isDisabled);
    const currentItemIndex = items.findIndex((item) => item.id === state.highlightedItemId);
    const currentItemIsFirst = currentItemIndex === 0;
    const lastIndex = items.length - 1;
    const prevItem = currentItemIndex === -1 || currentItemIsFirst ? items[lastIndex].id : items[currentItemIndex - 1].id;
    return {
      ...state,
      highlightedItemId: prevItem
    };
  }
  if (action.type === "highlight-next") {
    if (state.items.length === 0) {
      return state;
    }
    const parentId = (_b = state.items.find((item) => item.id === state.highlightedItemId)) == null ? void 0 : _b.parentId;
    const items = state.items.filter((item) => item.parentId === parentId && !item.isDisabled);
    const currentItemIndex = items.findIndex((item) => item.id === state.highlightedItemId);
    const currentItemIsLast = currentItemIndex === items.length - 1;
    const nextItem = currentItemIndex === -1 || currentItemIsLast ? items[0].id : items[currentItemIndex + 1].id;
    return {
      ...state,
      highlightedItemId: nextItem
    };
  }
  if (action.type === "highlight-submenu") {
    const parentId = state.highlightedItemId;
    const firstItemInSumbenu = state.items.find((item) => item.parentId === parentId);
    return {
      ...state,
      highlightedItemId: firstItemInSumbenu.id
    };
  }
  if (action.type === "add-item") {
    const newItem = action.payload;
    const isItemExists = state.items.find((item) => item.id === newItem.id);
    if (isItemExists) {
      return state;
    }
    return {
      ...state,
      items: [...state.items, newItem]
    };
  }
  if (action.type === "purge-menu-items") {
    const parentId = action.payload;
    const items = state.items.filter((item) => item.parentId !== parentId);
    return {
      ...state,
      items,
      highlightedItemId: state.keepHighlight ? state.highlightedItemId : "",
      keepHighlight: false
    };
  }
  if (action.type === "keep-highlight") {
    return {
      ...state,
      keepHighlight: true
    };
  }
  if (action.type === "set-search-presence") {
    return {
      ...state,
      hasSearch: true
    };
  }
  assertNever("Unexpected action: ", action);
}
function assertNever(message, x) {
  throw new Error(message + x);
}
export {
  initialState,
  reducer
};
//# sourceMappingURL=state.js.map
